import React, { useEffect, useRef } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ListAltIcon from '@material-ui/icons/ListAlt';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import * as storage from '../../utils/storage';
import { formatDate, toDisplayDecimal } from '../../utils';
import TimesheetSummaryDetail from './TimesheetSummaryDetail'
import TimesheetDayDetail from './TimesheetDayDetail'
import TimesheetBankBalance from './TimesheetBankBalance'
import TimesheetForm from './TimesheetForm'
import TimesheetDescriptionWeekDay from './TimesheetDescriptionWeekDay'
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import i18next from 'i18next';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AddIcon from '@material-ui/icons/Add';
import AlertAlgo from '../controls/AlertSnack'
import { listSummary, readyToApproveTimesheet } from '../../actions/timesheet';
import { Swipeable } from "react-swipeable";
import styles from '../../styles/timesheet.module.css';
import Fab from '@material-ui/core/Fab';
import { withNamespaces } from 'react-i18next';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { isIOS } from '../../utils';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAlarmClock } from "@fortawesome/pro-solid-svg-icons";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        marginTop: '5px'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
    },
    firstCell: {
        width: '30%',
        '@media (max-width: 400px)': {
            width: "35%"
        },
        paddingTop: '15px',
        paddingLeft: '15px',
        textAlign: 'right'
    },
    secondCell: {
        width: '30%',
        '@media (max-width: 400px)': {
            width: "35%"
        },
        paddingTop: '15px'
    },
    thirdCell: {
        width: '30%',
        '@media (max-width: 400px)': {
            width: "15%"
        },
    },
    fourthCell: {
        width: '10%',
        '@media (max-width: 400px)': {
            width: "15%"
        },
        paddingTop: '15px'
    },
    appBar: {
        top: 'auto',
        height: '35px!important',
        boxShadow: '0 9px 20px 0 !important',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important'
    },
    toolBar: {
        minHeight: '35px',
        paddingRight: '5px!important'
    },
    preApproved: {
        right: 0,
        position: 'absolute',
        marginRight: '5px',
    },
    total: {
        width: '100%',
        textAlign: 'center',
    },
    totalLabel: {
        fontSize: '20px !important'
    },
    appBarForm: {
        position: 'relative',
        backgroundColor: 'var(--color1) !important',
        color: 'var(--color2) !important',
    },
    titleAppBarForm: {
        marginLeft: theme.spacing(2),
        flex: 1,
    }
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function TimesheetSummary(props) {
    const classes = useStyles();

    const [expanded, setExpanded] = React.useState(false);
    const [allExpanded, setAllExpanded] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [openDetail, setOpenDetail] = React.useState(false);
    const [openBankBalance, setOpenBankBalance] = React.useState(false);
    const [detailDate, setDetailDate] = React.useState(null);
    const [targetDate, setTargetDate] = React.useState(null);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [timesheetId, setTimesheetId] = React.useState(0);
    const [data, setData] = React.useState(null);
    const [dataWeek, setDataWeek] = React.useState(null);
    const [dataDayDetail, setDataDayDetail] = React.useState(null);
    const [total, setTotal] = React.useState(0);
    const [statusReadyApprove, setStatusReadyApprove] = React.useState(false);
    const [isiOS, setIsiOS] = React.useState(isIOS());

    const openMenu = Boolean(anchorEl);

    const { startDate, endDate, onSaveForm, saveDate, onLoadComplete } = props;

    const alertRef = useRef(null);

    const handleLoadComplete = (status) => {
        onLoadComplete(status);
    }

    const handleEditTimesheet = (id) => {
        setTimesheetId(id);
        setOpen(true);
    };

    const handleCloseEditTimesheet = async (message, date) => {
        if (saveDate != date) {
            onSaveForm(date);
        }

        handleCloseForm(message);
    };

    const handleBankBalance = () => {
        setOpenBankBalance(true);
    }

    const handleAccordion = (panel) => (event, isExpanded) => {
        onSaveForm(null);

        if (allExpanded) {
            // This is to let open only the line that the user wants when all the lines are expanded
            isExpanded = true;
        }

        setAllExpanded(false);
        setExpanded(isExpanded ? panel : false);
    };

    const expandAllList = () => {
        const statusExpand = !allExpanded;
        setAllExpanded(statusExpand);
        setExpanded(false);

        storage.saveExpandedTimesheet(statusExpand);
    };

    const loadParamExpandedTimesheet = () => {
        let param = storage.getExpandedTimesheet();
        let expandedTimesheet = param || false;

        setAllExpanded(expandedTimesheet);
    }

    const handleCloseClick = () => {
        setOpen(false);
    };

    const handleCloseDetailClick = () => {
        setOpenDetail(false);
    };

    const handleCloseBankClick = () => {
        setOpenBankBalance(false);
    };

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleOpenDetail = (event, date, detailList) => {
        event.preventDefault();
        event.stopPropagation();
        onLoadComplete(true);
        setOpenDetail(true);
        setDetailDate(date);
        setDataDayDetail(detailList);
    };

    const handleMenuCloseClick = () => {
        setAnchorEl(null);
    };

    const handleNewMenuClick = () => {
        setTimesheetId(0);
        setTargetDate(new Date());
        setOpen(true);
        setAnchorEl(null);
    };

    const handleNewTimesheet = (date) => {
        setOpen(true);
        setTargetDate(date);
        setTimesheetId(0);
        onLoadComplete(false);
    }

    const handleReadyApproveMenuClick = () => {
        const isReadyToApproved = !statusReadyApprove;

        readyToApproveTimesheet(isReadyToApproved, startDate, endDate).then((response) => {
            if (response.status) {
                handleMenuCloseClick();
                if (isReadyToApproved === true) {
                    showMessage(i18next.t('timesheet:message.successReadyApprove'));
                }
                loadSummary().then(() => {
                    handleLoadComplete(false);
                });
            }
        });
    };

    const handleCloseForm = (value) => {
        let message = '';
        if (typeof (value) === 'string') {
            message = value;

            alertRef.current.showMessageSuccess(message);
        }
    };

    const showMessage = (message) => {
        alertRef.current.showMessageSuccess(message);
    }

    const showErrorMessage = (message) => {
        alertRef.current.showMessageError(message);
    }

    const StyledMenu = withStyles({
        paper: {
            border: '1px solid #d3d4d5',
        },
    })((props) => (
        <Menu
            elevation={0}
            getContentAnchorEl={null}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }}
            {...props}
        />
    ));

    const StyledMenuItem = withStyles((theme) => ({
        root: {
            '&:focus': {
                backgroundColor: "var(--color5)",
                '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
                    color: "rgb(55, 66, 74)",
                },
            },
        },
    }))(MenuItem);

    useEffect(() => {
        // The setTimeout is a workaround to make the label translation work. If the accordion is expanded right away in the page load the translation does not work
        setTimeout(() => { loadParamExpandedTimesheet() }, 1000);

        loadSummary();

        resizeForm();

        activeAccordionSave(saveDate);
    }, [startDate, saveDate]);

    useEffect(() => {
        if (detailDate != null && openDetail) {
            let detailList;

            data.forEach(item => {
                if (new Date(item.startDate).toDateString() === new Date(detailDate).toDateString()) {
                    detailList = item.tsDetail;
                }
            })

            if (detailList != null) {
                setDataDayDetail(detailList);
            }
        }
    }, [data]);

    const activeAccordionSave = (date) => {
        setExpanded(date);
    }

    const loadSummary = (targetDate = null) => {
        return new Promise((resolve) => {
            handleLoadComplete(true);
            listSummary(startDate, endDate).then((response) => {
                if (response != null) {
                    const list = JSON.parse(response.list);
                    setData(list.timesheetSummary);
                    setDataWeek(list.timesheetSummaryBySubCode);
                    setStatusReadyApprove(list.isReadyToApprove);
                    calculateTotal(list.timesheetSummary);
                    handleLoadComplete(false);
                    if (targetDate != null) {
                        const dayList = list.timesheetSummary.filter((obj) => formatDate(obj.startDate, 'date') == targetDate);
                        if (dayList == null
                            || dayList.length == 0
                            || (dayList.length == 1 && dayList[0].duration == 0)) {
                            setOpenDetail(false);
                        }
                    }
                    resolve();
                }
                else {
                    showErrorMessage(i18next.t('error:generic-error'));
                    handleLoadComplete(false);
                    resolve();
                }
            });
        });
    }

    const calculateTotal = (list) => {
        let sumDuration = 0;

        list.forEach(item => {
            sumDuration += item.duration;
        })

        setTotal(sumDuration);
    }

    const swipeEventLeft = () => {
        const btn = document.querySelector('#btnWeekAfter');
        btn.click();
    }

    const swipeEventRight = () => {
        const btn = document.querySelector('#btnWeekBefore');
        btn.click();
    }

    const resizeForm = () => {
        const height = window.innerHeight;
        const menu = document.querySelector('#menuFavorite').clientHeight;
        const appBarBottomPosition = height - (height - menu);
        document.querySelector('#appBarBottom').style.bottom = `${appBarBottomPosition}px`;

        const appBarBottom = document.querySelector('#appBarBottom').clientHeight;
        const offsetContextButton = isIOS ? 10 : 5;
        const contextButtonPosition = appBarBottomPosition + appBarBottom + offsetContextButton;
        document.querySelector('#contextButton').style.setProperty('bottom', `${contextButtonPosition}px`, 'important');

        setTimeout(function () {
            const titleBar = document.querySelector('#appBarTitle').clientHeight;
            const header = document.querySelector('#divWeekSelect').style.height;
            const customHeight = height - header - titleBar - menu;

            document.querySelector('#divSummary').style.height = `${customHeight}px`;
            document.querySelector('#divSummary').style.overflowX = 'hidden';
        }, 1000);
    }

    const onChangeDate = (date) => {
        setTargetDate(new Date(date));
    }

    return (
        <div id="divSummary" className={classes.root}>
            <AppBar position="fixed" id="appBarBottom" className={`${classes.appBar}`}>
                <Toolbar className={classes.toolBar}>
                    <IconButton edge="start" color="inherit" onClick={(event) => handleBankBalance()} aria-label="close">
                        <ListAltIcon />
                    </IconButton>

                    <div className={classes.total}>
                        <IconButton edge="start" color="inherit" onClick={expandAllList} aria-label="close" className={classes.totalLabel}>
                            {toDisplayDecimal(total)}
                            {!allExpanded && <ExpandLessIcon />}
                            {allExpanded && <ExpandMoreIcon />}
                        </IconButton>
                    </div>
                </Toolbar>
            </AppBar>
            <div className={styles.divReadyApprove}>
                <FormControlLabel
                    className={styles.approveCheckbox}
                    control={<Checkbox checked={statusReadyApprove} onChange={handleReadyApproveMenuClick} name="ckReadyApprove" />}
                    label={i18next.t('timesheet:form.readyToApprove')}
                />
            </div>
            <Swipeable onSwipedLeft={swipeEventLeft} onSwipedRight={swipeEventRight} preventDefaultTouchmoveEvent={true} trackTouch={true}>
                {data != null && data.map((obj, index) =>
                    <Accordion className={statusReadyApprove ? styles.accordionSummaryReadyApproved : styles.accordionSummary} key={index} expanded={expanded === formatDate(obj.startDate, 'date') || allExpanded} onChange={handleAccordion(formatDate(obj.startDate, 'date'))}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon className={statusReadyApprove ? styles.iconAccordionPreApproved : styles.iconAccordion} />}
                            aria-controls={`panel${formatDate(obj.startDate, "date")}-content`}
                            id={`panel${formatDate(obj.startDate, "date")}-content`}
                        >
                            <div className={classes.firstCell}>
                                <TimesheetDescriptionWeekDay date={obj.startDate} />
                            </div>
                            <div className={classes.secondCell}>{formatDate(obj.startDate, 'date')}</div>
                            <div className={classes.thirdCell}>
                                <IconButton edge="start" color="inherit" onClick={(event) => handleOpenDetail(event, obj.startDate, obj.tsDetail)} aria-label="close">
                                    <FontAwesomeIcon icon={faAlarmClock} style={{ width: "20px", height: "20px", marginRight: "5px" }} />
                                </IconButton>
                            </div>
                            <div className={classes.fourthCell}>{toDisplayDecimal(obj.duration)}</div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <TimesheetSummaryDetail date={obj.startDate} data={obj.tsSubCode} />
                        </AccordionDetails>
                    </Accordion>
                )}
            </Swipeable>


            <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition}>
                <div data-id="headerTimesheetForm">
                    <AppBar className={classes.appBarForm}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBarForm}>
                                {formatDate(targetDate, 'date')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divTimesheetForm">
                    <TimesheetForm timesheetId={timesheetId} targetDate={targetDate} onChangeDate={onChangeDate} onLoadSummary={() => loadSummary(targetDate)} onCloseForm={handleCloseClick} onCloseDetail={handleCloseDetailClick} onCloseEditTimesheet={handleCloseEditTimesheet} />
                </div>
            </Dialog>
            <Dialog fullScreen open={openDetail} onClose={handleCloseDetailClick} TransitionComponent={Transition}>
                <div data-id="headerTimesheetDetail">
                    <AppBar className={classes.appBarForm}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseDetailClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBarForm}>
                                {formatDate(detailDate, 'date')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divTimesheetDetail">
                    <Fab color="primary" aria-label="add" className={styles.addButtonFabDetail} onClick={() => handleNewTimesheet(detailDate)} >
                        <AddIcon />
                    </Fab>
                    <TimesheetDayDetail targetDate={detailDate} onEditTimesheet={handleEditTimesheet} data={dataDayDetail} onLoadComplete={onLoadComplete} />
                </div>
            </Dialog>
            <Dialog fullScreen open={openBankBalance} onClose={handleCloseBankClick} TransitionComponent={Transition}>
                <div data-id="headerTimesheetBalance">
                    <AppBar className={classes.appBarForm}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseBankClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBarForm}>
                                {i18next.t("timesheet:title.bankBalance")}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divTimesheetBank">
                    <TimesheetBankBalance data={dataWeek} />
                </div>
            </Dialog>
            <AlertAlgo ref={alertRef} />
            <Fab color="primary" id="contextButton" aria-label="add" className={`addButtonFabWithBar ${isiOS && "addButtonFabWithBarIOS"}`} onClick={() => handleNewTimesheet(formatDate(detailDate, 'date'))} >
                <AddIcon />
            </Fab>
        </div>
    );
}

export default withNamespaces(['timesheet', 'error'], { wait: true })(TimesheetSummary);